import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import SEO from "./SEO";

export default function ComplaintsInfo() {
  return (
    <div className="app">
      <SEO
        title="Reklamacije - TraveLina"
        description="Postupak podnošenja reklamacija i prigovora putnika."
        keywords="reklamacije, prigovor putnika, TraveLina"
      />
      <Navbar />
      <main>
        <section className="section" style={{ paddingTop: "6rem" }}>
          <div className="container">
            <article>
              <h1 style={{ marginBottom: "2rem", color: "#f97316", fontSize: "2rem" }}>
                Reklamacije
              </h1>
              <div
                style={{
                  padding: "2rem",
                  background: "#fafafa",
                  borderRadius: "0.75rem",
                  border: "1px solid rgba(0, 0, 0, 0.08)",
                  fontSize: "0.95rem",
                  lineHeight: "1.8",
                  color: "#111827",
                  whiteSpace: "pre-wrap",
                }}
              >
                {`Ako putnik ima prigovor na kvalitetu ugovorene usluge, dužan je bez odgađanja obavijestiti voditelja putovanja ili lokalnog pružatelja usluge kako bi se problem pokušao riješiti na licu mjesta.

Ako problem nije riješen tijekom putovanja, pisana reklamacija podnosi se organizatoru najkasnije u roku od 8 dana od završetka putovanja.

Reklamacija treba sadržavati:
- Ime i prezime putnika
- Naziv i datum putovanja
- Opis problema i okolnosti
- Dokaze (fotografije, računi, potvrde i sl.)
- Kontakt podatke za odgovor

Reklamacije se šalju na:
Email: info@linatravelina.eu
Adresa: TRAVELINA, OBRT ZA TRGOVINU I PRUŽANJE TURISTIČKIH USLUGA, VL. LINA SKENDER, CESARICA, PRIMORSKA 1

Organizator će pisano odgovoriti u zakonskom roku od 15 dana od zaprimanja potpune reklamacije.

Napomena:
Organizator može razmatrati samo reklamacije podnesene od strane ugovaratelja putovanja i u propisanom roku.`}
              </div>
            </article>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
